import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import styles from './style.scss';


const MenuItemsList = ({ items, pathname, onClickItem }) => {
  const elements = items.map((item) => (
    <li key={item.key}
      className={styles.item}>
      <Link
        key={item.key}
        to={item.url}
        onClick={onClickItem}
        className={classNames(
          styles.link, { activeLink: pathname.indexOf(item.url)!==-1 }
        )}>
        {item.text}
      </Link>
    </li>)
  );
  return elements;
};

MenuItemsList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.number.isRequired,
    url: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  })),
};

export default MenuItemsList;
